import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import Logo from "../Logo/Logo";
import "../../styles/auth.css";

const highlights = [
  "An AI tutor that explains step by step",
  "Quizzes with instant, personalized feedback",
  "Streaks, points and progress you can see",
];

// Split-screen shell for sign-in, sign-up and password pages
const AuthLayout = ({ children, heading, subheading }) => (
  <div className="auth-page">
    <aside className="auth-brand">
      <Link to="/" className="auth-brand-logo" aria-label="MyEduGenius home">
        <Logo light size={40} />
      </Link>

      <div className="auth-brand-copy">
        <h1>{heading || "Learning that adapts to you."}</h1>
        <p>
          {subheading ||
            "Personalized tutoring, smart quizzes and progress tracking for students and teachers."}
        </p>
        <ul>
          {highlights.map((item) => (
            <li key={item}>
              <CheckCircle2 size={18} />
              {item}
            </li>
          ))}
        </ul>
      </div>

      <div className="auth-brand-quote">
        <p>
          “The AI tutor helped me understand complex math concepts in minutes.”
        </p>
        <span>Sarah J. · Student</span>
      </div>
    </aside>

    <main className="auth-main">
      <Link to="/" className="auth-mobile-logo" aria-label="MyEduGenius home">
        <Logo size={34} />
      </Link>
      {children}
    </main>
  </div>
);

export default AuthLayout;
